import apiService from './apiService';

const blogPostService = {
  /**
   * Blogbejegyzések lekérdezése.
   * @param {object} params - Keresési és szűrési paraméterek (pl. page, limit, search, isPublished, tag).
   * @returns {Promise<object>}
   */
  getBlogPosts: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const response = await apiService.get(`/blogposts?${queryParams}`);
      return response;
    } catch (error) {
      console.error('Error fetching blog posts:', error);
      throw error;
    }
  },

  /**
   * Egy blogbejegyzés lekérdezése ID vagy slug alapján.
   * @param {string} identifier - A blogbejegyzés ID-ja vagy slugja.
   * @returns {Promise<object>}
   */
  getBlogPostByIdOrSlug: async (identifier) => {
    try {
      const response = await apiService.get(`/blogposts/${identifier}`);
      return response;
    } catch (error) {
      console.error(`Error fetching blog post ${identifier}:`, error);
      throw error;
    }
  },

  /**
   * Új blogbejegyzés létrehozása.
   * @param {object} blogPostData - A blogbejegyzés adatai.
   * @returns {Promise<object>}
   */
  createBlogPost: async (blogPostData) => {
    try {
      const response = await apiService.post('/blogposts', blogPostData);
      return response;
    } catch (error) {
      console.error('Error creating blog post:', error);
      throw error;
    }
  },

  /**
   * Blogbejegyzés frissítése.
   * @param {number} id - A blogbejegyzés ID-ja.
   * @param {object} blogPostData - A frissítendő adatok.
   * @returns {Promise<object>}
   */
  updateBlogPost: async (id, blogPostData) => {
    try {
      const response = await apiService.put(`/blogposts/${id}`, blogPostData);
      return response;
    } catch (error) {
      console.error(`Error updating blog post ${id}:`, error);
      throw error;
    }
  },

  /**
   * Blogbejegyzés törlése.
   * @param {number} id - A blogbejegyzés ID-ja.
   * @returns {Promise<object>}
   */
  deleteBlogPost: async (id) => {
    try {
      const response = await apiService.delete(`/blogposts/${id}`);
      return response;
    } catch (error) {
      console.error(`Error deleting blog post ${id}:`, error);
      throw error;
    }
  },
};

export default blogPostService;